import {
  Box,
  Button,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { FetchDailyVisitReportStore } from "../../../../../store/main/DailyVisitReportStore";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import { useEffect } from "react";
import { FetchState } from "../../../../../domain/models/fetch-state";
import DailyVisitReportModalLoading from "../../DailyVisitReportModalLoading";

type props = {
  open: boolean;
  setOpen: Function;
  day: number;
  userId: number;
  month: number;
  year: number;
  name: string;
  customerTypeId: string| null;
};

const VisitDataModal: React.FC<props> = ({
  open,
  setOpen,
  day,
  userId,
  month,
  year,
  name,
  customerTypeId,
}) => {
  const EditCustomerModalStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    borderRadius: "24px",
    boxShadow: 24,
    // p: 1,
  };

  const {
    FetchDayWiseVisitReport,
    FetchDayWiseVisitReportState,
    fetchDayWiseVisitReport,
  } = FetchDailyVisitReportStore();

  const { decodeToken } = CustomerDatabaseStore();

  const monthString = month.toString().padStart(2, "0");

  useEffect(() => {
    decodeToken();
    let params = {
      user_id: userId,
      day: day,
      month: monthString,
      year: year,
      customer_type_id: customerTypeId,
    };

    fetchDayWiseVisitReport(params);
  }, []);


  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  return (
    <>
      <Modal open={open}>
        <Box sx={EditCustomerModalStyle}>
          <Stack alignItems={"center"} justifyContent={"center"} spacing={1}>
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                padding: "3%",
                borderRadius: "24px",
              }}
            >
              {FetchDayWiseVisitReportState === FetchState.LOADING && (
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  height="65vh"
                >
                  <DailyVisitReportModalLoading />
                </Stack>
              )}

              <Typography
                style={{
                  fontWeight: "bolder",
                  fontSize: "18px",
                  textAlign: "left",
                  marginBottom: "1%",
                }}
              >
                Visit on ({formattedDay}/{formattedMonth}/{year}) for {name}
              </Typography>

              {FetchDayWiseVisitReportState === FetchState.SUCCESS && (
                <TableContainer sx={{ maxHeight: "60vh" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {[
                          "Id",
                          "Customer",
                          "Type",
                          "Brick Name",
                          "Last Update",
                        ].map((header) => (
                          <TableCell
                            key={header}
                            align="center"
                            sx={{
                              backgroundColor: "#f9fafd",
                              color: "#687182",
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {FetchDayWiseVisitReport.dailyVisitCounts &&
                      FetchDayWiseVisitReport.dailyVisitCounts.length > 0 ? (
                        FetchDayWiseVisitReport.dailyVisitCounts.map(
                          (detail) => (
                            <TableRow
                              key={detail.Visit_id}
                            >
                              <TableCell align="center">
                                {detail.Visit_id}
                              </TableCell>

                              <TableCell align="center">
                                <Typography>{detail.Customer}</Typography>
                              </TableCell>

                              <TableCell align="center">
                                <Typography>{detail.Type}</Typography>
                              </TableCell>

                              <TableCell align="center">
                                {detail.Brick_name ?? "-"}
                              </TableCell>

                              <TableCell align="center">
                                <Typography>{detail.Visit_date}</Typography>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={5}
                            sx={{
                              textAlign: "center",
                              padding: 2,
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                          >
                            No data available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              <Button
                variant="contained"
                onClick={() => setOpen(false)}
                sx={{
                  alignItems: "center",
                  marginX: "auto",
                  marginTop: "30px",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                Close
              </Button>
            </Paper>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default VisitDataModal;
